export default {
  id: 28,
  title: 'Target #28 - Cups & Balls',
  url: 'https://cssbattle.dev/play/28',
  colors: ['#1A4341', '#998235', '#F3AC3C'],
  solution:
    '<a a><a b><a c><style>body{background:#1a4341}a{position:fixed;width:50;height:50}a[a]{background:#998235;border-radius:50%;box-shadow:210px 0 #f3ac3c,70px 70px #998235,140px 70px #f3ac3c}a[a],a[b]{left:70}a[b],a[c]{background:#f3ac3c}a[a],a[c]{top:90}a[b]{border-radius:0 0 25px 25px;box-shadow:210px 0 #998235;top:160}a[c]{border-radius:25px 25px 0 0;box-shadow:70px 0 #998235;left:140}</style>',
}
